const en = {
	accountSet: 'account settings',
	pasdSet: 'password settings',
	langSet: 'language settings',
	selectLan: 'select interface language',
	simplifiedChinese: 'simplified chinese',
	changePassword: 'change password',
	tipsChangePaswd:
		'When changing the password, you need to enter the current password. If you forget the current password, you can',
	clickHere: 'click here',
	retrievePassword: 'retrieve password',
	currentPassword: 'current password',
	plCurrentPassword: 'Please input the current password',
	newPassword: 'new password',
	plNewPassword: 'Please input the new password',
	confirmPassword: 'confirm password',
	plConfirmPassword: 'Please enter the new password again',
	plTwoPasswords: 'The two passwords are inconsistent',
	saveSettings: 'save settings',
	setAvatar: 'set avatar',
	plSetAvatar:
		'Choose a personal positive photo as your avatar, and enterprise members can know you more easily',
	selectPhoto: 'select photo upload',
	personalData: 'personal data',
	codingSettings: 'Coding settings', //66
	prefix: 'prefix',
	digitalLength: 'Digital length',
	startingPosition: 'Starting position',
	pleaseEnter: 'Please enter',
	numLengthTips: 'The number length should be 3-10!',
	numberTips: 'For example: 4, it is 0000',
	numStartTips: 'The starting position cannot be greater than the number length!',
	numberPlaceholder:
		'For example: 10, it starts from the number 10 and cannot exceed the total length.',
	getNum: 'Generate code',
	example: 'example',
	forReferenceOnly: 'For reference only',
	accountSetting: 'account settings',
};
export default en;
